import { createFileRoute } from '@tanstack/react-router';
import { RulesLayout } from '@/features/rules/pages/rules-pages';

export const Route = createFileRoute('/_app/rules')({ component: RulesLayout });
